<template>
    <div class="flaws-display mt-3">
        <div class="d-flex justify-content-between mb-2 flex-wrap">
            <div class="mb-2">
                <h4 class="m-0">Flaws</h4>
            </div>
            <button
                class="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#manageFlawsModal"
            >
                <font-awesome-icon icon="pen-to-square" class="me-1" />Manage
            </button>
        </div>
        <hr />

        <!-- Character abilities -->
        <div v-for="(flaw, index) in character.flaws" :key="flaw.name">
            <div class="row">
                <div
                    class="col-sm-12 d-flex justify-content-between align-items-center"
                    @click="openModal(flaw)"
                >
                    <div
                        class="ability-card d-flex justify-content-between align-items-center"
                    >
                        <strong class="me-1">{{ flaw.name }}</strong>
                    </div>
                    <img
                        :src="getFlawImage(flaw.archetype)"
                        :alt="flaw.name"
                        class="rounded-3 d-none d-md-block"
                        style="max-width: 2rem"
                    />
                </div>
                <hr v-if="index < character.flaws.length - 1" />
            </div>
        </div>

        <!-- Bootstrap Modal -->
        <div
            class="modal fade"
            id="flawModal"
            tabindex="-1"
            aria-hidden="true"
            ref="flawModal"
        >
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div
                    class="modal-content bg-dark text-light rounded-3 shadow-lg"
                >
                    <div class="modal-header border-secondary">
                        <img
                            v-if="selectedFlaw"
                            :src="getFlawImage(selectedFlaw.archetype)"
                            :alt="selectedFlaw.name"
                            class="rounded-3 me-2"
                            style="max-width: 2rem"
                        />
                        <h4 class="modal-title" v-if="selectedFlaw">
                            {{ selectedFlaw.name }}
                        </h4>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            @click="closeModal"
                        ></button>
                    </div>
                    <div class="modal-body" v-if="selectedFlaw">
                        <div class="row">
                            <div class="col-sm-12 mt-3">
                                <p>{{ selectedFlaw.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                            @click="closeModal"
                        >
                            <font-awesome-icon
                                icon="multiply"
                                class="me-1"
                            />Close
                        </button>
                        <button
                            type="button"
                            class="btn btn-danger"
                            data-bs-dismiss="modal"
                            @click="deleteFlaw(selectedFlaw.name)"
                        >
                            <font-awesome-icon icon="trash-alt" /> Remove Flaw
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Manage Flaws Modal -->
        <div
            class="modal fade"
            id="manageFlawsModal"
            tabindex="-1"
            aria-hidden="true"
            ref="manageFlawsModal"
        >
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div
                    class="modal-content bg-dark text-light rounded-3 shadow-lg"
                >
                    <div class="modal-header border-secondary">
                        <h4 class="modal-title">Manage Flaws</h4>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            @click="closeManageFlawsModal"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="input-group mb-3">
                                    <span class="input-group-text"
                                        >Flaw to Add:</span
                                    >
                                    <select
                                        class="form-select"
                                        v-if="store.fatalFlaws"
                                        v-model="selectedFlaw"
                                    >
                                        <option value="">
                                            Please select...
                                        </option>
                                        <option value="all-flaws" disabled>
                                            ----Fatal Flaws----
                                        </option>
                                        <option
                                            v-for="flaw in store.fatalFlaws.sort(
                                                (a, b) =>
                                                    a.name.localeCompare(b.name)
                                            )"
                                            :key="flaw.name"
                                            :value="flaw.name"
                                        >
                                            {{ flaw.name }}
                                        </option>
                                        <option value="all-flaws" disabled>
                                            ----All Flaws----
                                        </option>
                                        <option
                                            v-for="flaw in store.flaws.sort(
                                                (a, b) =>
                                                    a.name.localeCompare(b.name)
                                            )"
                                            :key="flaw.name"
                                            :value="flaw.name"
                                        >
                                            {{ flaw.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row" v-if="selectedFlaw">
                                <div class="col-sm-12">
                                    <h4>
                                        {{
                                            store.fatalFlaws.find(
                                                (f) => f.name === selectedFlaw
                                            )?.name ||
                                            store.flaws.find(
                                                (f) => f.name === selectedFlaw
                                            )?.name
                                        }}
                                    </h4>
                                </div>
                                <div class="col-sm-12">
                                    <p>
                                        {{
                                            store.fatalFlaws.find(
                                                (f) => f.name === selectedFlaw
                                            )?.description ||
                                            store.flaws.find(
                                                (f) => f.name === selectedFlaw
                                            )?.description
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                            @click="selectedFlaw = ''"
                        >
                            <font-awesome-icon
                                icon="multiply"
                                class="me-1"
                            />Close
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            data-bs-dismiss="modal"
                            @click="
                                character.flaws.push(
                                    store.fatalFlaws.find(
                                        (f) => f.name === selectedFlaw
                                    ) ||
                                        store.flaws.find(
                                            (f) => f.name === selectedFlaw
                                        )
                                );
                                store.updateCharacter(character);
                                selectedFlaw = '';
                            "
                            :disabled="!selectedFlaw"
                        >
                            <font-awesome-icon icon="plus" class="me-1" />Add
                            Flaw
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import { useRosterStore } from "../stores/index";

export default {
    name: "FlawsDisplay",
    props: {
        flaws: {
            type: Array,
            default: () => [],
        },
        characterId: {
            type: Number,
            required: true,
        },
        theme: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            selectedFlaw: "",
            modalInstance: null,
            character: {},
            store: useRosterStore(),
        };
    },
    methods: {
        deleteFlaw(flaw) {
            if (!flaw) return;

            if (confirm(`Are you sure you want to delete ${flaw}?`)) {
                const index = this.character.flaws.findIndex(
                    (f) => f.name === flaw
                );
                if (index !== -1) {
                    this.character.flaws.splice(index, 1);
                }

                // Reset selection
                this.selectedFlaw = "";
            }
        },
        async fetchCharacter() {
            const store = useRosterStore();
            try {
                this.character = await store.getCharacterById(this.characterId);
                this.character.abilities?.sort((a, b) => a - b);
            } catch (error) {
                console.error("Failed to fetch character", error);
            }
        },
        getFlawImage(stat) {
            if (!stat || stat.toLowerCase() === "none") stat = "survivor";
            return require(`@/../public/img/${stat}${this.theme}.png`);
        },

        getFlawById(id) {
            const store = useRosterStore();
            return store.flaws.find((f) => f.id === id);
        },

        getFlawName(id) {
            const flaw = this.getFlawById(id);
            return flaw ? flaw.name : "Unknown Flaw";
        },

        openModal(flaw) {
            this.selectedFlaw = flaw;

            if (!this.modalInstance) {
                this.modalInstance = new Modal(this.$refs.flawModal);
            }
            this.modalInstance.show();
        },

        openModalById(flawId) {
            this.selectedFlaw = this.getFlawById(flawId);

            if (!this.modalInstance) {
                this.modalInstance = new Modal(this.$refs.flawModal);
            }
            this.modalInstance.show();
        },

        closeModal() {
            this.selectedFlaw = null;
            if (this.modalInstance) this.modalInstance.hide();
        },
    },
    created() {
        this.fetchCharacter();
    },
    watch: {
        characterId: "fetchCharacter",
    },
};
</script>

<style scoped>
.flaws-display {
    padding: 10px 5px;
    border: solid 2px #555;
    border-radius: 8px;
}

.flaw-card {
    padding: 8px;
    /* margin-bottom: 6px; */
    cursor: pointer;
    transition: background 0.2s;
}
</style>

